import React, { ForwardedRef, useContext } from 'react';
import { OriginIconProps } from '../type';
import { Context } from '../context';

function IconPublishedComponent(props: OriginIconProps, ref: ForwardedRef<SVGSVGElement>) {
    const { prefix: prefixFromContext } = useContext(Context);
    const { className = '', prefix: prefixFromProps, width = '1em', height = '1em', useCurrentColor = true, spin, ...rest } = props;

    const prefix = prefixFromProps || prefixFromContext || 'alliance';
    const loadingKls = spin ? ` ${prefix}-icon-loading` : '';
    return <svg className={`${prefix}-icon ${prefix}-icon-Published${loadingKls} ${className}`} width={width} height={height} viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest} ref={ref}><path fill={useCurrentColor ? 'currentColor' : '#fff'} d="M0.224 0.91H24.224V24.91H0.224z"/><circle cx="12.224" cy="12.91" r="11" fill={useCurrentColor ? 'currentColor' : '#FFE8E8'}/><path d="M15.786 12.0264C16.3701 12.4703 16.3701 13.3488 15.786 13.7927L11.4308 17.1026C10.7005 17.6577 9.65039 17.1368 9.65039 16.2195L9.65039 9.59956C9.65039 8.68223 10.7005 8.16136 11.4308 8.71642L15.786 12.0264Z" fill={useCurrentColor ? 'currentColor' : '#FF6970'}/></svg>;
}

const IconPublished = React.forwardRef(IconPublishedComponent);
export default IconPublished;
